<div class="page-wrap">
  <div class="replace-matcard">
    <mat-card-header>
      <h1 *ngIf="this.wagonId < 1; else elseBlock">{{wagon?.addTitel}}</h1>
      <ng-template #elseBlock>
        <h1>{{wagon?.editTitel}}</h1>
      </ng-template>
      <label>{{wagon?.chooseOtherWagonDescription}}</label>
      <mat-form-field class="w-350">
        <mat-label>{{wagon?.wagonSelectionLabel}}</mat-label>
        <mat-select disableOptionCentering="true" (selectionChange)="changeWagon($event.value)"
          [(value)]="selectedWagon">
          <mat-option class="select-without-checkbox" *ngFor="let wagon of wagons" [value]="wagon.id">
            {{wagon.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-header>
    <mat-card-content class="card-content">
      <div class="content-container">
        <form [formGroup]="wagonForm" class="form-container">
          <mat-form-field appearance="outline" class="width-100">
            <mat-label>{{wagon?.wagonNameLabel}}</mat-label>
            <input matInput autoComplete="off" formControlName="name">
            <mat-error *ngIf="wagonForm.get('name')?.hasError('required')">
              {{wagon?.validation?.required}}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="width-100">
            <mat-label>{{wagon?.wagonDescriptionLabel}}</mat-label>
            <input matInput autoComplete="off" formControlName="description">
          </mat-form-field>
          <mat-form-field appearance="outline" class="width-100" (click)="clearWagonDimension('wagonLength')">
            <mat-label>{{wagon?.wagonLengthLabel}}</mat-label>
            <input matInput type="number" autoComplete="off" step="1" min="0" max="500000"
              (keyup)="checkWagonDimensionIsMax('xSize',500000)" (keypress)="disableKeyPressE($event)"
              (focusout)="addZeroToWagonDimension('wagonLength')" id="wagonLength" formControlName="xSize">
            <mat-error *ngIf="wagonForm.get('xSize')?.hasError('required')">
              {{wagon?.validation?.required}}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="width-100" (click)="clearWagonDimension('wagonWidth')">
            <mat-label>{{wagon?.wagonWidthLabel}}</mat-label>
            <input matInput type="number" step="1" min="0" max="5000" (keypress)="disableKeyPressE($event)"
              (keyup)="checkWagonDimensionIsMax('ySize',5000)" autoComplete="off"
              (focusout)="addZeroToWagonDimension('wagonWidth')" id="wagonWidth" formControlName="ySize">
            <mat-error *ngIf="wagonForm.get('ySize')?.hasError('required')">
              {{wagon?.validation?.required}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="width-100">
            <mat-label>{{wagon?.wagonFloorSelection}}</mat-label>
            <mat-select [(value)]="selectedFloor" (selectionChange)="changeFloor($event.value)"
              [disabled]="wagonEdit === false">
              <mat-option class="select-without-checkbox" *ngFor="let floorType of floorTypeList"
                [value]="floorType.id">
                {{floorType.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="wagonForm.get('floorCount')?.hasError('required')">
              {{wagon?.validation?.required}}
            </mat-error>
          </mat-form-field>
          <div *ngIf="editMode">
            <button mat-raised-button class="button margin-right" (click)="setBoolValues(true,false)"
              [disabled]="createClassDefinitionButtonDisabledState()">{{wagon?.class?.createButton}}</button>
            <button mat-raised-button class="button margin-right" (click)="setBoolValues(false,true);resetClasses()"
              [disabled]="wagonEdit === true">{{wagon?.class?.resetButton}}</button>
            <div *ngIf="classEdit">
              <app-wagon-class-creation [serviceClasses]="serviceClasses" [maxValue]="wagonForm.get('xSize').value"
                [yLength]="wagonForm.get('ySize').value" [floorCount]="wagonForm.get('floorCount').value"
                (classes)="setClasses($event)"></app-wagon-class-creation>
            </div>
          </div>
          <div *ngIf="!editMode">
            <app-wagon-class-presentation *ngIf="classes != null" [serviceClasses]="serviceClasses"
              [classes]="classes"></app-wagon-class-presentation>
          </div>
        </form>
      </div>
    </mat-card-content>
    <div class="content-buttons">
      <button mat-raised-button class="color" (click)="navigateBack()">{{wagon?.buttonBack}}</button>
      <div class="spacer"></div>
      <button mat-raised-button class="color" type="submit" (click)="onSubmit()"
        [disabled]="wagonForm.invalid">{{wagon?.buttonSave}}</button>
    </div>
  </div>
</div>
<hr class="line">